<template>
   <div id='myClass'>
      <!-- <j-dict-select-tag :defaultShowAll="true" type="radioButton" @change="handleChangeType" v-model="courseType"
         :trigger-change="true" dictCode="course_type" /> -->
         <a-row>
            <div class="data_box classBox" :loading="true">
               <div class="listTips" v-if="dataSource.length == 0">暂无数据</div>
                <div class="box_list" v-show="dataSource.length > 0" v-for="item,index in dataSource" :key="index" @click="toDetail(item.id)">
                    <img :src="item.cmsCover_url" alt="">
                    <p class="box_text box_text1" style="">{{ item.cmsTitile }}</p>
                </div>
            </div>

        </a-row>
   </div>
</template>
<script>
import {getAction} from "@/api/manage"
export default {
   name: 'myClass',
   components: {},
   data() {
      return {
         courseType: "",
         loading:false,
         dataSource:[]
      }
   },
   computed: {},
   watch: {},
   methods: {
      init() {
         this.loading = true
         this.dataSource = []
         getAction("/teaching/teachingCms/getCmsList", {
            cmsStatus: 1,
            // cmsType: 8,
            cmsCategoryId: 10,
            orderBy:'time',
            pageSize: 999,
            pageSize: 999,
         }).then(res => {
            console.log(res);
            if (res.success) {
               this.dataSource = res.result.records
            }
            this.loading = false
         })
      },
      toDetail(id) {
         this.$router.push({
            path: 'CmsDetail',
            query: {
               id: id,
            },
         })
      },
      handleChangeType(e) {
         this.courseType = e.target.value
         this.init()
      },
   },
   created() { },
   mounted() { this.init()},
}
</script>
<style lang='scss' scoped>
#myClass {
   width: 100%;
   height: auto;
   background: #fff;
   padding: 15px;
   position: relative;
}
</style>